import { gql } from '@apollo/client';

export const CREATE_SIMPLE_PROCESS = gql`
    mutation CreateSimpleProcess($input: CreateSimpleProcess!) {
        facility {
            process {
                createSimpleProcess(input: $input) {
                    id
                }
            }
        }
    }
`;
